// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prepend_account_code div.input-group-text{color:#fff;background-color:#3da5de!important;border:1px solid #3da5de!important}", ""]);
// Exports
module.exports = exports;
